export default __webpack_public_path__ + "static/flight-2-bb14e9c38aa3459863700a69a03a35f1.jpg";